import React, { useState, useEffect } from "react";
import { getAllPreparation, newPreparation, updatePreparation, removePreparation } from "../../services/product/preparation";
import { getAllPreparationMethod } from "../../services/product/preparationMethod";

import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    PlusCircle,
    Trash2,
} from "react-feather";
import PreparationForm from "../../core/modals/products/preparationFormModel";
import { useParams } from "react-router-dom";



const PreparationPage = () => {
    const { id } = useParams();
    const [listData, setListData] = useState([]);
    const [methodListData, setMethodListData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showModel, setModelShow] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        try {
            if (id) {
                const data = await getAllPreparation(id);
                setListData(data);
            }
            const data = await getAllPreparationMethod();
            setMethodListData(data);
        } catch (err) {
            console.error("Failed to load addresses:", err.message);
        }
    };

    const filteredData = listData.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const handleShow = () => {
        setSelectedData(null);
        setModelShow(true)
    };

    const handleClose = () => setModelShow(false);
    const handleAddPrep = async (data) => {
        try {
            if (data.ProductPreparationID) {
                await updatePreparation(data);
            }
            else {
                await newPreparation(data);
            }
            await fetchRecords();
            setModelShow(false);
        } catch (err) {
            console.error("Error creating user:", err.message);
        }
    };

    const handleDeletePreparation = async (row) => {
        const comboId = Number(row?.ProductPreparationID) || 0;
        if (!comboId) return console.error("Missing ProductPreparationID:", row);

        if (!window.confirm("Delete this preparation?")) return;

        try {
            await removePreparation(comboId);
            await fetchRecords();
        } catch (err) {
            alert(err?.response?.data?.Message || "Failed to delete Preparation.");
        }
    };

    const handleEditProduct = (record) => {
        setSelectedData(record);
        setModelShow(true);
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Preparations</h4>
                            <h6>Manage Your Preparation</h6>
                        </div>
                    </div>
                    <div className="page-btn">
                        <Button variant="none" className="btn btn-added" onClick={handleShow}>
                            <PlusCircle className="me-2" />
                            Add New Preparation
                        </Button>
                    </div>
                </div>
                <div className="card table-list-card">
                    <div className="card-body">
                        <div className="table-top">
                            <div className="search-set">
                                <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <Link to className="btn btn-searchset">
                                        <i data-feather="search" className="feather-search" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>Preparation Method</th>
                                        <th>Method ShortCode</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.ProductName || "N/A"}</td>
                                                <td>{item.PreparationMethod || "N/A"}</td>
                                                <td>{item.MethodShortCode || "N/A"}</td>
                                                <td>
                                                    <button type='button'
                                                        onClick={() => handleEditProduct(item)}
                                                        className="btn btn-sm btn-primary me-2">
                                                        <i className="feather-edit"></i>
                                                    </button>
                                                    {/* ✅ Delete (red dustbin) */}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeletePreparation(item)}
                                                        className="btn btn-sm btn-light me-2"
                                                        title="Delete"
                                                        style={{
                                                            border: "1px solid #f1c0c0",
                                                        }}
                                                    >
                                                        <Trash2 size={16} color="red" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {showModel &&
                <PreparationForm
                    onSubmit={handleAddPrep}
                    showModel={showModel}
                    handleClose={handleClose}
                    data={selectedData}
                    methodList={methodListData}
                    id={id}
                />
            }
        </div>
    );
};


export default PreparationPage;
